const events = [
  {
    no: 1,
    title: "Ihh Wibu Founded",
    description: "Ihh Wibu Firstly Founded on Event with 10 members",
    date: "2022 January 22",
  },
  {
    no: 2,
    title: "New Event 2",
    description: "Description of the second event.",
    date: "Date 2",
  },
  {
    no: 3,
    title: "New Event 3",
    description: "Description of the third event.",
    date: "Date 3",
  },
  {
    no: 3,
    title: "New Event 3",
    description: "Description of the third event.",
    date: "Date 3",
  },
  {
    no: 3,
    title: "New Event 3",
    description: "Description of the third event.",
    date: "Date 3",
  },
  {
    no: 3,
    title: "New Event 3",
    description: "Description of the third event.",
    date: "Date 3",
  },
  {
    no: 3,
    title: "New Event 3",
    description: "Description of the third event.",
    date: "Date 3",
  },
  {
    no: 3,
    title: "New Event 3",
    description: "Description of the third event.",
    date: "Date 3",
  },
  // Add more events as needed
];

const Timeline = () => {
  return (
    <div className="bg-indigo-500 p-4">
      <div className="flex flex-col grid-cols-9 p-2 mx-auto md:grid">
        <h2 className="text-3xl text-white font-bold mb-12">History</h2>
        
        {events.map((event, index) => 
          index % 2 === 0 ? (
            <div key={event.no} className="flex md:contents flex-row-reverse">
              <div className="relative p-4 my-6 text-gray-800 bg-white rounded-xl col-start-1 col-end-5 mr-auto md:mr-0 md:ml-auto">
                <h3 className="text-lg font-semibold lg:text-xl">{event.title}</h3>
                <p className="mt-2 leading-6">{event.description}</p>
                <span className="absolute text-sm text-indigo-100/75 -top-5 left-2 whitespace-nowrap">
                  {event.date}
                </span>
              </div>
              <div className="relative col-start-5 col-end-6 mr-7 md:mx-auto">
                <div className="flex items-center justify-center w-6 h-full">
                  <div className="w-1 h-full bg-indigo-300 rounded-t-full bg-gradient-to-b from-indigo-400 to-indigo-300"></div>
                </div>
                <div className="absolute w-6 h-6 -mt-3 bg-white border-4 border-indigo-400 rounded-full top-1/2"></div>
              </div>
            </div>
          ) : (
            <div key={event.no} className="flex md:contents">
              <div className="relative col-start-5 col-end-6 mr-7 md:mx-auto">
                <div className="flex items-center justify-center w-6 h-full">
                  <div className="w-1 h-full bg-indigo-300"></div>
                </div>
                <div className="absolute w-6 h-6 -mt-3 bg-white border-4 border-indigo-400 rounded-full top-1/2"></div>
              </div>
              <div className="relative p-4 my-6 text-gray-800 bg-white rounded-xl col-start-6 col-end-10 mr-auto">
                <h3 className="text-lg font-semibold lg:text-xl">{event.title}</h3>
                <p className="mt-2 leading-6">{event.description}</p>
                <span className="absolute text-sm text-indigo-100/75 -top-5 left-2 whitespace-nowrap">
                  {event.date}
                </span>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Timeline;
